import React from 'react'
import Icon from '../misc/Icons'
import SectionMarker from '../uiKit/SectionMarker'
import LiveViewDropdown from './LiveViewDropdown'



class LiveViewToolBar extends React.Component{
	

	render(){
		const {minimiseLiveView,section,stopLiveView,isEmptyState}=this.props

	

		return(
			<div 
				style={{height: `${this.props.toolBarHeight}px`}}
				className={'liveView-toolbar ' + (this.props.liveViewEmpty ? ' liveView-toolbar--empty ' : ' liveView-toolbar--nonEmpty ')}>	
			
				{!section &&
					<div className='liveView-toolbar-liveStatusIndicator liveView-toolbar-liveStatusIndicator--spacer' />						
				}

				{section && 
					<div className='liveView-toolbar-liveStatusIndicator liveView-toolbar-liveStatusIndicator--live'>
						Live
						<SectionMarker type={'colorOnly'} label='Live' section={section} />
					</div>
				}

				{section &&
					<div className='liveView-toolbar-sectionName'>
						{section.name}
					</div>
				}
				<LiveViewDropdown />
						
				
				{!isEmptyState &&
					<button data-tooltip='Minimize' onClick={()=>{minimiseLiveView()}} className='liveView-toolbar-btn liveView-toolbar-btn--minimize tooltip tooltip--label'>
						<Icon name='minimize' />
					</button>
				}
				<button data-tooltip='Close' onClick={()=>{stopLiveView()}} className='liveView-toolbar-btn liveView-toolbar-btn--close tooltip tooltip--label'>
					<Icon name='close' />
				</button>

			</div>
		)
	}
}





export default LiveViewToolBar






// WEBPACK FOOTER //
// ./src/components/liveView/LiveViewToolBar.js